import { usePositionOptionsGet } from '@sbv-clients/data-access-api';
import { useProLaborLevelDesignations } from '@sbv-clients/data-access-api';

import {
  BaseFieldProps,
  createOptionsFieldBuilder,
} from '../hoc/fields-builder';

const dataFetcher = usePositionOptionsGet;
type ExtraParameters = Parameters<typeof dataFetcher>[0];
type Props = BaseFieldProps & ExtraParameters;

const hookParamsGetter = (props: Props): ExtraParameters => ({
  filteredByOpeningTemplates: props.filteredByOpeningTemplates,
});

export const {
  PositionSelectField,
  PositionFormSelectField,
  PositionDataGridSelectField,
  PositionIdToLabelRenderer,
} = createOptionsFieldBuilder({
  prefix: 'Position',
  useOptionsHook: usePositionOptionsGet,
  extractHookParams: hookParamsGetter,
  useLabelHook: () => useProLaborLevelDesignations().PositionLaborLevel,
});
